import React from 'react';
import { Typography } from '@mui/material';

const Chargebacks = () => <Typography variant="h6">Chargebacks</Typography>;
export default Chargebacks;
